export const ACTION_TYPE_PASSWORD_RECOVERY: string = 'password-recovery';
export const ACTION_TYPE_VERIFICATION: string = 'verification';
export const ACTION_TYPE_VERIFICATION_SETUP: string = 'verification-setup';
